import script from "./subAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./subAccount.vue?vue&type=script&setup=true&lang=js"

import "./subAccount.vue?vue&type=style&index=0&id=e2185534&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2185534"]])

export default __exports__